import { render, staticRenderFns } from "./LearningMap.vue?vue&type=template&id=3c97a2e2&scoped=true&lang=pug&"
import script from "./LearningMap.vue?vue&type=script&lang=ts&"
export * from "./LearningMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97a2e2",
  null
  
)

export default component.exports